import React, { Fragment, useRef, useState, useEffect } from 'react';
import { func, string } from 'prop-types';

import Modal from '../../Modal';
import Button from '../../Button';
import { ReactComponent as PostIcon } from '../../BoxMessage/assets/post.svg';
import { ReactComponent as FileIcon } from '../assets/file.svg';

import s from './index.module.css';

const FileInput = ({ onPost, resetImagePreview, onSendMessage, imagePreview }) => {
  const fileInput = useRef();
  const [imageUrl, setImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [caption, setCaption] = useState('');

  const selectImage = (event) => {
    const files = event.target.files || event.dataTransfer.files;

    if (!files.length) {
      return;
    }

    onPost(files[0]);
  };

  const close = () => {
    setShowModal(false);
    fileInput.current.value = null;
    setImage(null);
    resetImagePreview();
  };

  const postMessage = () => {
    onSendMessage({ image: imagePreview, caption });
    setCaption('');
    close();
  };

  useEffect(() => {
    if (imagePreview) {
      setImage(imagePreview);
    }

    return () => {
      setImage(null);
    };
  }, [imagePreview]);

  useEffect(() => {
    if (imageUrl) {
      setShowModal(true);
    }
  }, [imageUrl]);

  return (
    <Fragment>
      <label className={s.fileInput}>
        <input ref={fileInput} type="file" accept="image/png, image/jpeg" onChange={selectImage} />
        <FileIcon width={20} height={20} color={'#7E7E7E'} />
      </label>

      {showModal && imageUrl && (
        <Modal className={s.modal} onClose={close}>
          <div className={s.modalBody}>
            <img className={s.image} src={imageUrl} alt=""></img>
            <div className={s.captionInputWrapper}>
              <input
                onChange={(e) => setCaption(e.target.value)}
                placeholder="Добавьте описание"
                className={s.captionInput}
              ></input>
              <Button className={s.postButton} onClick={postMessage}>
                <PostIcon />
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

FileInput.propTypes = {
  className: string,
  imagePreview: string,
  onPost: func,
  onSendMessage: func,
};

FileInput.defaultProps = {
  className: null,
  imagePreview: null,
  onPost: () => {},
  onSendMessage: () => {},
};

export default FileInput;
